import React from 'react';
import { WebLink } from '../customComponents';
import { TrendingUp, ArrowRight } from 'lucide-react';

const FundRecordsNavigation = ({ activeTab = 'deposits' }) => {
    return (
        <div className="flex flex-col lg:flex-row gap-4">
            <WebLink 
                to="/deposit-records" 
                className={`group relative p-8 rounded-3xl border transition-all duration-500 transform hover:-translate-y-2 hover:shadow-2xl cursor-pointer flex-1 overflow-hidden ${
                    activeTab === 'deposits' 
                        ? 'bg-gradient-to-br from-green-500/20 to-green-600/20 border-green-400/30 shadow-green-500/20' 
                        : 'bg-white/5 border-white/10 hover:bg-white/10'
                }`}
            >
                {/* Active indicator */}
                <div className={`absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-green-500 to-green-600 transition-opacity duration-300 ${
                    activeTab === 'deposits' ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'
                }`}></div>
                
                <div className="flex items-center gap-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-3xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                        <TrendingUp className="text-white" size={28} />
                    </div>
                    <div className="flex-1">
                        <h3 className={`font-bold text-xl mb-2 transition-colors ${
                            activeTab === 'deposits' 
                                ? 'text-green-100' 
                                : 'text-white group-hover:text-green-100'
                        }`}>Deposits</h3>
                        <p className="text-gray-300 text-sm leading-relaxed">View your comprehensive deposit history and transaction details</p>
                        {activeTab !== 'deposits' && (
                            <div className="mt-3 flex items-center text-green-400 text-sm font-medium">
                                <span>View History</span>
                                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" size={16} />
                            </div>
                        )}
                    </div>
                </div>
                
                {/* Decorative elements */}
                <div className="absolute -top-4 -right-4 w-24 h-24 bg-green-500/10 rounded-full blur-xl group-hover:bg-green-500/20 transition-colors duration-500"></div>
            </WebLink>

            <WebLink 
                to="/withdrawal-records" 
                className={`group relative p-8 rounded-3xl border transition-all duration-500 transform hover:-translate-y-2 hover:shadow-2xl cursor-pointer flex-1 overflow-hidden ${
                    activeTab === 'withdrawals' 
                        ? 'bg-gradient-to-br from-red-500/20 to-red-600/20 border-red-400/30 shadow-red-500/20' 
                        : 'bg-white/5 border-white/10 hover:bg-white/10'
                }`}
            >
                {/* Active indicator */}
                <div className={`absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-500 to-red-600 transition-opacity duration-300 ${
                    activeTab === 'withdrawals' ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'
                }`}></div>
                
                <div className="flex items-center gap-6">
                    <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-3xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                        <TrendingUp className="text-white rotate-180" size={28} />
                    </div>
                    <div className="flex-1">
                        <h3 className={`font-bold text-xl mb-2 transition-colors ${
                            activeTab === 'withdrawals' 
                                ? 'text-red-100' 
                                : 'text-white group-hover:text-red-100'
                        }`}>Withdrawals</h3>
                        <p className="text-gray-300 text-sm leading-relaxed">Track your withdrawal requests and payment status</p>
                        {activeTab !== 'withdrawals' && (
                            <div className="mt-3 flex items-center text-red-400 text-sm font-medium">
                                <span>View History</span>
                                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-300" size={16} />
                            </div>
                        )}
                    </div>
                </div>
                
                {/* Decorative elements */}
                <div className="absolute -top-4 -right-4 w-24 h-24 bg-red-500/10 rounded-full blur-xl group-hover:bg-red-500/20 transition-colors duration-500"></div>
            </WebLink>
        </div>
    );
};

export default FundRecordsNavigation;
